import { render } from "./metamask.vue?vue&type=template&id=1b957be4&scoped=true"
const script = {}

import "./metamask.vue?vue&type=style&index=0&id=1b957be4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b957be4"]])

export default __exports__